import { Fragment } from 'react';
import { FaCheck } from 'react-icons/fa';
import * as S from './styles';

export const WizardContainer = S.WizardContainer;
export const WizardBody = S.WizardBody;
export const StepContent = S.StepContent;

export function Stepper({ steps, activeKey, onSelect }) {
  const activeIndex = steps.findIndex((step) => step.key === activeKey);

  return (
    <S.StepperContainer>
      {steps?.map((step, index) => {
        const status =
          index === activeIndex ? 'active' : index < activeIndex ? 'done' : 'pending';

        return (
          <Fragment key={step.key}>
            <S.StepButton type="button" onClick={() => onSelect(step.key)}>
              <S.StepCircle status={status}>
                {status === 'done' ? <FaCheck size={12} /> : index + 1}
              </S.StepCircle>
              <S.StepLabel status={status}>{step.label}</S.StepLabel>
            </S.StepButton>
            {index < steps.length - 1 && <S.StepLine filled={index < activeIndex} />}
          </Fragment>
        );
      })}
    </S.StepperContainer>
  );
}
